import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { fetchEntityAuditLogs } from '../../../../store/slices/audit-slice';
import EntityAuditLogsTable from './entity-audit-logs-table';

function EntityAuditLogs(props) {
  const { entityPk: tablePK, field } = props;
  const { name: entityId } = field;

  const tableSchema = field.tableSchema ?? null;

  const auditLogsFetchStatus = useSelector(
    (state) => state.audit.entityLogsFetch.status,
  );

  const dispatch = useDispatch();

  // Should update name of props and make less specifict to assetTypes
  let tableName = null;
  if (entityId === 1) {
    tableName = 'GasContainers';
  } else if (entityId === 2) {
    tableName = 'LiquidContainers';
  } else if (entityId === 3) {
    tableName = 'DewarContainers';
  } else if (entityId === 4) {
    tableName = 'LiquidChassis';
  } else if (entityId === 5) {
    tableName = 'WorkOrders';
  } else if (entityId === 6) {
    tableName = 'MaintenanceRequests';
  } else if (entityId === 8) {
    tableName = 'PurchaseRequests';
  } else if (entityId === 9) {
    tableName = 'PurchaseOrders';
  } else if (entityId === 10) {
    tableName = 'Parts';
  } else if (entityId === 'DewarCustomers') {
    tableName = 'DewarCustomers';
  } else if (entityId === 'LiquidCustomers') {
    tableName = 'LiquidCustomers';
  } else if (entityId === 'GasCustomers') {
    tableName = 'GasCustomers';
  } else if (entityId === 'LiquidCustomerPricing') {
    tableName = 'LiquidCustomerPricing';
  } else if (entityId === 'MaintenanceRequestLineItems') {
    tableName = 'MaintenanceRequestLineItems';
  } else if (entityId === 'Locations') {
    tableName = 'Locations';
  } else if (entityId === 'LocationLiquidPurityRequirements') {
    tableName = 'LocationLiquidPurityRequirements';
  } else if (entityId === 'LocationGasPurityRequirements') {
    tableName = 'LocationGasPurityRequirements';
  } else if (entityId === 'GasReceivers') {
    tableName = 'GasReceivers';
  } else if (entityId === 'LocationAnalyzers') {
    tableName = 'LocationAnalyzers';
  } else if (entityId === 'NitrogenTanks') {
    tableName = 'NitrogenTanks';
  } else if (entityId === 'FillSlots') {
    tableName = 'FillSlots';
  } else if (entityId === 'RTU') {
    tableName = 'RTU';
  } else if (typeof entityId === 'string') {
    tableName = entityId;
  }

  useEffect(() => {
    dispatch(fetchEntityAuditLogs({ tableName, tablePK, tableSchema }));
  }, [tableName, tablePK, tableSchema]);

  const auditLogsAreLoading = auditLogsFetchStatus === 'loading';

  return (
    <div className="h-100 d-flex">
      <Spinner animation="border" variant="primary" className={`create-spinner${auditLogsAreLoading ? ' visible' : ' invisible'}`} />
      <EntityAuditLogsTable />
    </div>
  );
}

export default EntityAuditLogs;
